import { Marker, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import { useTrack } from '../context/TrackContext';
import { STATIONS } from '../data/stations';

export default function StationsMapLayer() {
    const { anchorsBalagne, anchorsCentrale } = useTrack();
    const anchors = [...anchorsBalagne, ...anchorsCentrale];

    return (
        <>
            {anchors
                .filter(anchor => anchor && anchor.coord && !isNaN(anchor.coord[0]) && !isNaN(anchor.coord[1]))
                .map(anchor => {
                const stationInfo = STATIONS.find(s => s.name === (anchor as any).name);
                const type = stationInfo?.type || 'Arrêt';

                return (
                    <Marker
                        key={(anchor as any).name + Math.random()}
                        position={anchor.coord}
                        icon={L.divIcon({
                            className: 'station-icon',
                            html: `
                                <div class="relative flex flex-col items-center">
                                    <div class="w-3 h-3 bg-white border-2 ${type === 'Gare' ? 'border-orange-500 w-4 h-4' : 'border-slate-500'} rounded-full shadow-md z-10"></div>
                                    <div class="absolute top-4 bg-black/60 backdrop-blur text-white text-[9px] px-1.5 py-0.5 rounded border border-white/10 whitespace-nowrap font-bold uppercase tracking-tighter shadow-xl transform transition-all">
                                        ${(anchor as any).name}
                                    </div>
                                </div>
                            `,
                            iconSize: [20, 20],
                            iconAnchor: [10, 10]
                        })}
                    >
                        <Tooltip direction="top" offset={[0, -10]} opacity={0.9}>
                            <div className="text-center">
                                <strong className="block text-cyan-500 uppercase text-xs">{(anchor as any).name}</strong>
                                <span className="text-[10px] text-slate-500">PK {anchor.pk.toFixed(3)}</span>
                            </div>
                        </Tooltip>
                    </Marker>
                );
            })}
        </>
    );
}
